const colors = {
  primary: "#01337E",
  secondary: "#EEE",
  accent: "#FFFFFF",
};

export default colors;
